import * as types from './types'
import storage from '@/plugins/storage'
const cleanAdas = {
  firm: 0,
  adas: null,
  adasType: 0,
  ronumber: '',
  insurance: null,
  notes: '',
  vehicle: {
    vehicle: -1,
    firm: 0,
    contact: 0,
    year: '2010',
    make: 0,
    model: '',
    bodystyle: '',
    vin: ''
  },
  createdBy: 0,
  status: 1
}
const cleanInspection = {
  firm: 0,
  adasInspection: JSON.parse(JSON.stringify(cleanAdas)),
  adas: null,
  ronumber: '',
  insurance: null,
  adasInspectionType: 0,
  inspector: null,
  notes: null,
  status: 1
}
export default () => ({
  default: JSON.parse(JSON.stringify(cleanAdas)),
  defaultInspection: JSON.parse(JSON.stringify(cleanInspection)),
  pageSize: storage.session.getItem(types.ADAS_PAGE_SIZE) || 10,
  searchTerm: storage.session.getItem(types.ADAS_SEARCH_TERM) || '',
  sortDir: storage.session.getItem(types.ADAS_SORT_DIR) || 'desc',
  orderBy: storage.session.getItem(types.ADAS_ORDER_BY) || 'Adas',
  filterBy: parseInt(storage.local.getItem(types.ADAS_FILTER_BY)) || null,
  filterOptions: [],
  adass: [],
  adas: null,
  adasInspections: [],
  adasInspection: null,
  highlightSave: false,
  isAdasChecked: false,
  adasInspectionResults: [],
  reportPreference: null,
  adasInspectionItems: [],
  adasDecodeInfo: null,
  links: [],
  decoded: null
})



// WEBPACK FOOTER //
// ./src/store/modules/adas/state.js